module.exports = __webpack_public_path__ + "static/media/label-2-over.4bc67f0c.svg";